<template>
  <CardBase shadow="always" class="p-4 text-shade-900 md:p-10">
    <InfoIcon class="w-10 h-10 text-primary-400" />
    <ul>
      <li v-for="(item, i) in infoNavigation" :key="i" class="mt-4 md:mt-6">
        <button
          class="group w-full h-full text-left hover:text-primary-400 transition-colors duration-200 ease-in-out"
          @click="goToHash(item.anchor)"
        >
          <div class="flex gap-2 items-center text-mobile-lg font-semibold">
            <span class="flex-initial first-letter:uppercase">
              {{ item.title }}
            </span>
            <ArrowRightIcon
              class="mt-0.5 w-5 h-5 transition-transform duration-200 ease-out translate-x-0 group-hover:translate-x-2 stroke-current stroke-1"
            />
          </div>

          <div class="text-base text-shade-500">{{ item.subtitle }}</div>
        </button>
      </li>
    </ul>
  </CardBase>
</template>
<script lang="ts" setup>
import { useI18n } from '#i18n'
import ArrowRightIcon from '~/assets/icon/navigation/Arrow/Right.svg'
import InfoIcon from '~/assets/icon/general/Info.svg'
const { t } = useI18n()

// Info navigation
const infoNavigation: Record<string, any> = [
  {
    title: t('index.info_nav.resources_types_title'),
    subtitle: t('index.info_nav.resources_types_subtitle'),
    anchor: '#resource_type',
  },
  {
    title: t('index.info_nav.media_library_title'),
    subtitle: t('index.info_nav.media_library_subtitle'),
    anchor: '#media_library',
  },
  {
    title: t('index.info_nav.historical_structure_title'),
    subtitle: t('index.info_nav.historical_structure_subtitle'),
    anchor: '#historical_structure',
  },
  {
    title: t('index.info_nav.credits_title'),
    subtitle: t('index.info_nav.credits_subtitle'),
    anchor: '#credits',
  },
]

const goToHash = (hash) => {
  location.hash = hash
}
</script>
